/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_Pending_HintInputs */



/**
* | output |
* | --- |
* | "Waiting to sync with vekn.net. It retries on its own." |
*
* @param {Vekn_Sync_Pending_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_pending_hint = /** @type {((inputs?: Vekn_Sync_Pending_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_Pending_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En attente de synchronisation avec vekn.net. Nouvel essai automatique.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pendiente de sincronizar con vekn.net. Se reintenta solo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aguardando sincronização com vekn.net. Tenta de novo sozinho.")
	if (locale === "it") return /** @type {LocalizedString} */ ("In attesa di sincronizzazione con vekn.net. Riprova da solo.")
	return /** @type {LocalizedString} */ ("Waiting to sync with vekn.net. It retries on its own.")
});